import { serviceAreaProvidersListComponent } from './service-area-providers-list.component';
import './service-area-providers-list.scss';

export const serviceAreaProvidersList = angular
    .module('components.serviceArea.serviceAreaProvidersList',[])
    .component('serviceAreaProvidersList',serviceAreaProvidersListComponent)
    .name;


// WEBPACK FOOTER //
// ./src/app/components/service-area/service-area-providers-list/service-area-providers-list.module.js